/**
 * Licensed Materials - Property of IBM
 *
 * IBM Cognos Products: BI Glass
 *
 * (C) Copyright IBM Corp. 2017, 2021
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define({
		"rtl": "Jobbról balra",
		"timeZoneID": "Időzóna",
		"skin": "Stílus",
		"metricsFileImportTask": "Új importálás fájlokból",
		"displayMode": "Alapértelmezett nézet",
		"credentialRenewed": "Hitelesítő adatai megújultak a jelenlegi felhasználói azonosítójával és jelszavával.",
		"productLocale": "Termék nyelve",
		"toggleDisabled": "ki",
		"credentialChange": "Megújítás",
		"log_level_Debug": "Hibakeresés",
		"confirmNewPassword": "Új jelszó megerősítése",
		"unsavedViewMsg2": "A módosításai elvesznek, ha először nem menti azokat.",
		"supportPortalErrorMessage": "Próbálja újra.  Ha a probléma továbbra is fennáll, forduljon az adminisztrátorhoz.",
		"legalText": "Licenc hatálya alá tartozó anyagok – Az IBM Corp. tulajdona. © Copyright IBM Corporation és más(ok) 2005, %{year}. Az IBM, az IBM embléma, az ibm.com és a Cognos az International Business Machines Corp. védjegye vagy bejegyzett védjegye a világ számos országában. Az IBM védjegyeinek aktuális listája az interneten a következő címen érhető el: www.ibm.com/legal/copytrade.shtml. A Program használata a programot kísérő licencszerződés feltételei szerint engedélyezett. A licencszerződés a programkönyvtár mappájában, illetve a License vagy a Non_IBM_License nevű könyvtárban (ha van ilyen) található, illetve nyomtatott formában van mellékelve a programhoz. A program használatának megkezdése előtt olvassa el figyelmesen a szerződést. A Program használatbavétele a feltételek elfogadását jelenti.",
		"groupsAndRoles": "Csoportok és szerepek",
		"metricsMaintenanceTask": "Új karbantartás",
		"email": "E-mail cím",
		"contextual": "Környezetfüggő",
		"resetHome": "Visszaállítás az alapértelmezett értékekre",
		"ltr": "Balról jobbra",
		"credentials": "Hitelesítő adatok",
		"logging_congfig_title": "Naplózás",
		"changePasswordTitle": "Jelszó módosítása",
		"format": "Jelentésformátum",
		"showUnread": "Olvasatlan elemek megjelenítése",
		"AILearning_active": "Az MI tanulás be van kapcsolva:",
		"docsErrorMessage": "Próbálja újra.  Ha a probléma továbbra is fennáll, forduljon az adminisztrátorhoz.",
		"toggleEnabled": "be",
		"homeSetError": "Hiba történt az alapértelmezett kezdőlap beállításakor. Próbálja meg bezárni és újra megnyitni ezt a nézetet.",
		"passwordChange": "Jelszó módosítása",
		"profile": "Profil",
		"pdfRestricted": "PDF (Korlátozott)",
		"drillThrough": "Átfúrásmeghatározások",
		"homeSet": "A kezdőlap beállítása sikeres",
		"regionalOptions": "Területi beállítások",
		"myPreferences": "Saját beállítások",
		"defaultHome": "Alapértelmezett",
		"version": "Változat",
		"controller": "Controller",
		"manage": "Kezelés",
		"biDirectionalFeaturesEnabled": "Két írásirányú nyelvek támogatása",
		"newFeaturesErrorTitle": "Az Új szolgáltatásokra mutató hivatkozás nem működött",
		"passwordMatch": "A jelszavak egyeznek",
		"updateProfileAndsettings": "Profil és beállítások frissítése",
		"dashboardConsole": "Munkaterület",
		"legacyAppsSlideoutLabel": "Elérhető örökölt alkalmazások",
		"logging_config_description": "A naplózás a hibaelhárítás során használható. A beállításokkal kapcsolatos útmutatásért forduljon a rendszergazdához.",
		"confirmDeletion": "Törlés megerősítése",
		"signInButtonText": "Bejelentkezés",
		"dataSourceCredentials": "Adatszerver hitelesítő adatai",
		"AILearningConfigurationSlideoutAllyLabel": "MI tanulás konfiguráció",
		"loadingSettings": "Beállítások betöltése",
		"spreadsheetMLRestricted": "Excel (Korlátozott)",
		"manageAILearning": "MI tanulás",
		"xlsxDataRestricted": "Excel adatok (Korlátozott)",
		"advanced": "Speciális beállítások",
		"ok": "OK",
		"changeEmail": "Módosítás",
		"showHints": "Tippek megjelenítése",
		"general": "Általános",
		"xlsxData": "Excel-adatok",
		"newPassword": "Új jelszó",
		"hideAll": "Az összes elrejtése",
		"confirmPassword": "Jelszó megerősítése",
		"AILearning_config_description": "Fejlessze tovább a terméken belüli javaslatokat azzal, hogy lehetővé teszi a Cognos Analytics számára, hogy tanuljon termékhasználatából.",
		"metricStudio": "Studio",
		"supportPortalErrorTitle": "A támogatási portálra mutató hivatkozás nem működött",
		"log_level_Warn": "Figyelmeztetés",
		"contentSettings": "Tartalombeállítások",
		"setHomeButton": "Halmaz",
		"myCapabilities": "Saját képességek",
		"homePage": "Kezdőlap",
		"helpErrorMessage": "Próbálja újra.  Ha a probléma továbbra is fennáll, forduljon az adminisztrátorhoz.",
		"loadingProfile": "Profil betöltése",
		"portal": "Portál",
		"metricsPackage": "Új csomag",
		"myCredentials": "Saját hitelesítő adatok",
		"credentialCreate": "Létrehozás",
		"eventStudio": "Event Studio",
		"updatePWUnknownError": "A jelszó nem frissíthető",
		"showHiddenObjects": "Rejtett bejegyzések megjelenítése",
		"csv": "CSV",
		"docsErrorTitle": "A dokumentációra mutató hivatkozás nem működött",
		"log_level_Error": "Hiba",
		"wrongPassword": "Nem lehet hitelesíteni",
		"productName": "IBM Cognos Analytics %{version}",
		"log_level_Info": "Információ",
		"welcomeBanner": "Üdvözlő fejléccsík",
		"helpErrorTitle": "A Súgóra mutató hivatkozás nem működött",
		"contentLocale": "Tartalom nyelve",
		"pdf": "PDF",
		"oldPassword": "Régi jelszó",
		"spreadsheetML": "Excel",
		"accessibilityFeatures": "Kisegítő lehetőségek",
		"manageLogging": "Naplózás",
		"loggingConfigurationSlideoutA11yLabel": "Naplózási konfiguráció",
		"communityErrorTitle": "A Közösségre mutató hivatkozás nem működött",
		"companionApps": "Társalkalmazások",
		"setHomeLabel": "Kezdőlap beállítása mint (aktuális nézet)",
		"metricsExportTask": "Új exportálás",
		"csvRestricted": "CSV (Korlátozott)",
		"newFeaturesErrorMessage": "Próbálja újra.  Ha a probléma továbbra is fennáll, forduljon az adminisztrátorhoz.",
		"contributor": "Contributor",
		"showAll": "Az összes megjelenítése",
		"logging_active": "Naplózás bekapcsolva:",
		"html": "HTML",
		"profileAndSettings": "Profil és beállítások",
		"baseTextDirection": "Szöveg alapiránya",
		"queryStudio": "Query Studio",
		"metricsManager": "Metrics Manager",
		"password": "Jelszó",
		"invalidEmail": "Adjon meg egy érvényes e-mail címet",
		"credentialCreateSuccess": "Sikeresen létrehozta hitelesítő adatait",
		"settings": "Beállítások",
		"restrictedFormatSelected": "Ebben a formátumban nem tud jelentést futtatni, de az ebben a formátumban mentett jelentésekhez hozzáférhet.",
		"usageDataDeletionConfirmation": "A használati adatok törlése visszaállít minden MI tanulást.  Biztosan törölni kívánja a használati adatokat?",
		"powerplayStudio": "PowerPlay Studio",
		"viewDetails": "Részletek megjelenítése",
		"deleteUsageData": "Használati adatok törlése:",
		"showPassword": "Jelszó megjelenítése",
		"AILearning_config_title": "MI tanulás",
		"myPreferencesSlideoutLabel": "Profil és beállítások",
		"passWordChangeSuccess": "Sikeresen módosította a jelszót",
		"logging_level": "Naplózási szint:",
		"analysisStudio": "Analysis Studio",
		"communityErrorMessage": "Próbálja újra.  Ha a probléma továbbra is fennáll, forduljon az adminisztrátorhoz.",
		"cancel": "Mégse",
		"shareSetError": "Ez a művelet jelenleg nem végezhető el a nézet bezárása és újbóli megnyitása előtt.",
		"passwordNotMatch": "Hoppá, a jelszavak nem egyeznek",
		"xml": "XML",
		"xmlRestricted": "XML (Korlátozott)",
		"openMenu": "Menü megnyitása",
		"closeMenu": 'Menü bezárása'
});